import { useEffect, useState } from "react";
import { BellRing, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const PERIODS = [["today", "Hari ini"], ["d7", "7 hari"], ["d30", "30 hari"]];
const fmt = (iso) => (iso || "").slice(0, 16).replace("T", " ");
const mask = (p) => (p ? `•••${p.slice(-4)}` : "-");

const Stat = ({ label, value, tone = "text-zinc-900", testid }) => (
  <div className="border border-border rounded-sm p-3 bg-zinc-50">
    <div className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</div>
    <div className={`text-2xl font-bold font-mono mt-1 ${tone}`} data-testid={testid}>{value}</div>
  </div>
);

const Result = ({ r }) => {
  if (r.sent && !r.failed && !r.removed) return <span className="text-emerald-700 font-semibold">Terkirim {r.sent}</span>;
  return (
    <span className="text-[11px]">
      <span className="text-emerald-700">{r.sent} terkirim</span>
      {!!r.failed && <span className="text-rose-700"> · {r.failed} gagal</span>}
      {!!r.removed && <span className="text-zinc-500"> · {r.removed} token dihapus</span>}
    </span>
  );
};

export const PushStatsCard = () => {
  const [d, setD] = useState(null);
  const [period, setPeriod] = useState("today");
  const load = () => api.pushStats().then(setD).catch(() => {});
  useEffect(() => { load(); }, []);
  const p = d?.periods?.[period] || {};

  return (
    <div className="border border-border rounded-sm bg-white p-4" data-testid="push-stats-card">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <BellRing className="w-4 h-4 text-[#E65100]" />
        <h2 className="font-semibold">Notifikasi Push Pelanggan</h2>
        <span className="text-[11px] text-zinc-500">Notifikasi gratis saat teknisi OTW (Android / Desktop).</span>
        <Button variant="ghost" size="sm" className="ml-auto h-7" onClick={load} data-testid="push-stats-refresh">
          <RefreshCw className="w-3.5 h-3.5" />
        </Button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Pelanggan aktif" value={d?.customers ?? "-"} tone="text-[#E65100]" testid="push-stat-customers" />
        <Stat label="Perangkat terdaftar" value={d?.tokens ?? "-"} testid="push-stat-tokens" />
        <Stat label="Notifikasi terkirim" value={p.sent ?? "-"} tone="text-emerald-700" testid="push-stat-sent" />
        <Stat label="Gagal / token dihapus" value={d ? `${p.failed || 0} / ${p.removed || 0}` : "-"} tone="text-rose-700" testid="push-stat-failed" />
      </div>
      <div className="flex items-center gap-2 mt-3">
        <div className="inline-flex rounded-sm border border-border overflow-hidden" data-testid="push-period-toggle">
          {PERIODS.map(([k, l]) => (
            <button key={k} onClick={() => setPeriod(k)} data-testid={`push-period-${k}`}
              className={`px-3 py-1 text-[11px] font-semibold transition-colors ${period === k ? "bg-[#E65100] text-white" : "bg-white text-zinc-600 hover:bg-zinc-50"}`}>
              {l}
            </button>
          ))}
        </div>
        <span className="text-[11px] text-zinc-500">{p.wo ?? 0} WO OTW dengan notifikasi</span>
      </div>
      <div className="mt-4">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1.5">20 pengiriman terakhir</div>
        {!d?.recent?.length ? (
          <div className="text-[12px] text-zinc-500 italic py-3" data-testid="push-recent-empty">Belum ada notifikasi yang dikirim.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-[12px]" data-testid="push-recent-table">
              <thead><tr className="text-left text-zinc-500 border-b">
                <th className="py-1.5 pr-3 font-medium">Waktu</th><th className="pr-3 font-medium">Pelanggan</th>
                <th className="pr-3 font-medium">No HP</th><th className="font-medium">Hasil</th>
              </tr></thead>
              <tbody>
                {d.recent.map((r, i) => (
                  <tr key={i} className="border-b last:border-0" data-testid={`push-recent-row-${i}`}>
                    <td className="py-1.5 pr-3 font-mono whitespace-nowrap">{fmt(r.at)}</td>
                    <td className="pr-3">{r.customer_name || "-"}</td>
                    <td className="pr-3 font-mono">{mask(r.phone)}</td>
                    <td><Result r={r} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
